import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

export const signOutUser = createAppAsyncThunk(
  'auth/signOutUser',
  async (_, { extra: { authGateway, snackbarGateway } }) => {
    try {
      await authGateway.signOut();
    } catch (error) {
      snackbarGateway.error(translate('Logout.Message.error'));
      throw error;
    }
  },
);
